import PropTypes from 'prop-types';
import React from 'react';
import resolveUserImage from '../../services/resolve-user-image';
import styles from './post-image.scss';

const PostImage = ({ image, url, isPublic }) => {
  const props = isPublic ? { 'data-pin-url': url } : { 'data-pin-nopin': true };
  return (
    <div className={styles.container}>
      <img className={styles.image} src={resolveUserImage(image)} {...props}/>
    </div>
  );
};

PostImage.propTypes = {
  image: PropTypes.object.isRequired,
  url: PropTypes.string,
  isPublic: PropTypes.bool,
};

export default PostImage;



// WEBPACK FOOTER //
// ./app/components/post-image/post-image.js